import { render, staticRenderFns } from "./EditableTableStandard.vue?vue&type=template&id=40cc3ed4&"
import script from "./EditableTableStandard.vue?vue&type=script&lang=js&"
export * from "./EditableTableStandard.vue?vue&type=script&lang=js&"
import style0 from "./EditableTableStandard.vue?vue&type=style&index=0&id=40cc3ed4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports